module.exports = __webpack_public_path__ + "images/thumb-8bb6c668979fe1ad8f5a468421e8ca26.jpg";